module.exports = __webpack_public_path__ + "img/jd_telecom.85e4bf35.png";